import { $t } from "@/plugins/i18n";
import { account } from "@/router/enums";

export default {
  path: "/account-settings",
  redirect: "/account-settings/profile",
  meta: {
    icon: "ri/user-settings-line",
    title: $t("menus.accountSettings"),
    rank: account,
    showLink: false,
    forbid: true
  },
  children: [
    {
      path: "/account-settings/profile",
      name: "Profile",
      component: () => import("@/views/account-settings/profile.vue"),
      meta: {
        title: $t("menus.profile")
      }
    },
    {
      path: "/account-settings/bill",
      name: "Bill",
      component: () => import("@/views/account-settings/bill.vue"),
      meta: {
        title: $t("menus.bill")
      }
    }
  ]
} satisfies RouteConfigsTable;
